var _style, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 45",
    style: {
      enableBackground: "new 0 0 42 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.pcc{clip-path:url(#SVGID_2_);fill:#E5A337;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 2.9,
    width: 42,
    height: 39.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pcc",
    d: "M40.1,23.4c-2.8-3.8-4.7-7.2-6.3-9.9l-3.1,3.1l-4.4-4.4L30.5,8c-2.4-3.3-5-5.1-10.4-5.1C9,2.9,0,11.4,0,23.4 c0,12,8.6,18.7,19.7,18.7C30.8,42.1,47.6,33.6,40.1,23.4 M12.1,37.7c-1.3,0-2.3-1.1-2.3-2.3c0-1.3,1.1-2.3,2.3-2.3 c1.3,0,2.3,1.1,2.3,2.3C14.4,36.6,13.4,37.7,12.1,37.7 M16,38.2c-0.6,0-1.1-0.5-1.1-1.1S15.4,36,16,36c0.6,0,1.1,0.5,1.1,1.1 S16.6,38.2,16,38.2 M21.3,34.9c-0.2,0.2-0.4,0.3-0.7,0.4c-0.3,0-0.5-0.1-0.7-0.3l-3-3l4.6-5c0.3-0.4,0.3-1-0.1-1.3 c-0.4-0.3-1-0.3-1.3,0.1l-4.5,4.9l-3.3-3.3l4.9-4.5c0.4-0.3,0.4-0.9,0.1-1.3c-0.3-0.4-0.9-0.4-1.3-0.1l-5,4.6l-3-3 c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.4-0.7l9.4-7.3l11.2,11.2L21.3,34.9z M29.9,23.8L29.8,24L18.9,13.1l0.2-0.2 c1.7-1.3,4.2-1.2,5.7,0.4l4.8,4.8C31.1,19.6,31.3,22.1,29.9,23.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCc);
export default __webpack_public_path__ + "static/media/product-cc.d05aa25ec00d2069f156c7c434c53e6c.svg";
export { ForwardRef as ReactComponent };